// @ts-nocheck
import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(userListUsersTableStyles, {
    pagination: {
        cssOverrides: {
            pagination: css`
                && {
                    margin-top: ${x => x.theme.design.myAccount.pagination.spacing};
                }
            `,
        },
    },
    noResultsContainer: {
        css: css`
            text-align: left;
            padding: ${pxToRem(30)} 0;
        `,
    },
    noResultsText: {
        variant: "h3",
    },
});
